import { useDispatch, useSelector } from 'react-redux'

import clsx from 'clsx'

import { setActiveDepartment } from 'app/redux/messages/messages.actions'
import { setMessengerTabState } from 'app/redux/widget/widget.actions'
import { LeftArrow } from '../icons'
import { convertHtmlToPlainText } from 'app/utils/text'
import { setWidgetTab, setlauncherContent } from 'app/redux/widget/widget.actions'
import { MESSENGER_TAB_STATE, LAUNCHER_CONTENT_STATE } from 'app/constants/launcherContentStates'
import DepartmentLogo from '../DepartmentLogo'
import { DEFAULT_AVATAR_NAME } from 'app/constants/avatar'
import './messageItem.scss'

const getAllDepartments = ({ messagesData }) => messagesData.departments.data
const getLanguageInfo = ({ widgetData }) => widgetData.widgetInfo.languageInfo
const getUserInput = ({ messagesData }) => messagesData.messages.userInput
const getFaqs = ({ widgetData }) => widgetData.widgetInfo.faq

const MessageItem = ({ department }) => {
  const dispatch = useDispatch()

  const allDepartments = useSelector(getAllDepartments)
  const languageInfo = useSelector(getLanguageInfo)
  const userInput = useSelector(getUserInput)
  const faqs = useSelector(getFaqs)

  const departmentId = department._id
  const operators = department.operators
  const textInTeamInputBox = userInput[departmentId]

  // checks if any custom image is set by customer or not
  const isCustomDepartmentLogoSet = department.logo && !department.logo.includes(DEFAULT_AVATAR_NAME)

  const departmentData = allDepartments.find((item) => item._id === department._id)

  const showNewMsgBadge = departmentData?.notSeenMsgsCount > 0

  const getLatestMessage = () => {
    const departmentMessages = departmentData?.messages

    return departmentMessages?.[departmentMessages.length - 1]
  }
  const getLatestMessageContent = () => {
    const latestMessage = getLatestMessage()

    const { type } = latestMessage || {}

    if (type === 'image') {
      return '🖼️'
    } else if (type === 'vidoe') {
      return '🎞️'
    } else if (type === 'audio') {
      return '🎵'
    } else if (['file', 'compress'].includes(type)) {
      return '📁'
    }

    if (latestMessage?.isAutoMessage) {
      return convertHtmlToPlainText(latestMessage.content)
    }

    return latestMessage?.content ?? ''
  }

  const getLastDialoge = () => {
    // check if there is any drafted text in team input
    if (textInTeamInputBox) {
      return `${languageInfo.texts.draft}: ${textInTeamInputBox}`
    }

    return getLatestMessageContent()
  }

  const handleClickTeamContainer = () => {
    dispatch(setActiveDepartment(departmentId))

    handleLauncherContentAfterClick()
  }

  const handleLauncherContentAfterClick = () => {
    if (faqs?.length) {
      dispatch(setWidgetTab(1))
      dispatch(setMessengerTabState(MESSENGER_TAB_STATE.CHAT))
      return
    }
    dispatch(setlauncherContent(LAUNCHER_CONTENT_STATE.FIRST_CHAT))
  }

  const getTeamContainerClasses = () => {
    return clsx(
      'team_item_image_container',
      showNewMsgBadge && 'team_item_with_new_message',
      operators.length > 3 && isCustomDepartmentLogoSet && 'team_item_is_team',
    )
  }

  return (
    <li className="team_item_main_container__wrapper">
      <div onClick={handleClickTeamContainer} className="team_item_main_container">
        <div className={getTeamContainerClasses()}>
          <DepartmentLogo operators={operators} logo={department.logo} name={department.name} />
        </div>
        <div className="team_item_message_container">
          <div className="team_item_message_sender raychat-font-bold">
            <span className="team_item_message_sender__title">{department.name}</span>
          </div>
          <p className="team_item_message">{getLastDialoge()}</p>
        </div>

        <div className="team_item_message_time">
          <LeftArrow />
        </div>
      </div>
    </li>
  )
}

export default MessageItem
